import { combineReducers } from 'redux';
import series from './series';

export default combineReducers({
  series,
});
